/* Reway FAQ-matcher — client-side relevance matching (geen backend).
   Gedeeld door de klantenservice-zoeker en de contact-live-antwoorden. */
(function () {
  var STOP = ('de het een en of ook als dan nog maar wel niet hoe wat waar wie welke waarom kan kun kunt moet mag heb heeft hebben ' +
    'krijg krijgen ben bent zijn was wordt word worden ga gaat gaan doe doet doen wil wilt willen zou zul zult mijn jouw uw onze ' +
    'deze die dat dit hier daar er even graag alstublieft aub svp voor van met naar bij aan om over per dus toch echt keer nou ' +
    'iets iemand ergens even nogmaals verder soort ding dingen zeg maar').split(' ');
  var STOPMAP = {}; STOP.forEach(function (w) { STOPMAP[w] = 1; });

  /* Synoniemen / intenties: getypt woord -> verwante termen die in de FAQ's voorkomen.
     Ruim opgezet zodat alledaagse formuleringen (bezorgtijd, kwijt, pinnen, ...) toch matchen. */
  var SYN = {
    // bezorging / levering
    bezorgtijd: ['levertijd', 'bezorgen', 'verzending', 'duurt', 'werkdagen', 'levering', 'geleverd'],
    bezorgtijden: ['levertijd', 'bezorgen', 'verzending', 'werkdagen', 'levering'],
    levertijd: ['bezorgen', 'verzending', 'levering', 'werkdagen', 'duurt', 'geleverd'],
    leverdatum: ['levertijd', 'bezorgen', 'geleverd', 'levering'],
    verzendtijd: ['levertijd', 'bezorgen', 'verzending', 'werkdagen'],
    verzendduur: ['levertijd', 'bezorgen', 'verzending', 'werkdagen'],
    bezorgen: ['bezorgd', 'levering', 'geleverd', 'verzending', 'levertijd'],
    bezorging: ['bezorgen', 'bezorgd', 'levering', 'levertijd', 'verzending'],
    bezorgd: ['bezorgen', 'geleverd', 'levering'],
    geleverd: ['bezorgd', 'bezorgen', 'levering', 'levertijd'],
    levering: ['bezorgen', 'levertijd', 'verzending', 'geleverd', 'bezorgd'],
    duurt: ['levertijd', 'bezorgen', 'werkdagen', 'lang'],
    lang: ['levertijd', 'duurt', 'bezorgen', 'werkdagen'],
    thuisbezorgd: ['bezorgen', 'bezorgd', 'levering'],
    // pakket / zending / tracking
    pakket: ['bestelling', 'zending', 'verzending', 'bezorgen', 'geleverd'],
    pakketje: ['bestelling', 'zending', 'bezorgen', 'geleverd'],
    pakketpost: ['bestelling', 'zending', 'bezorgen'],
    zending: ['verzending', 'bezorgen', 'bestelling', 'pakket'],
    postnl: ['bezorgen', 'verzending', 'zending', 'track'],
    dhl: ['bezorgen', 'verzending', 'zending', 'track'],
    kwijt: ['bezorgd', 'ontvangen', 'zending', 'niets', 'vermist'],
    vermist: ['bezorgd', 'ontvangen', 'zending', 'kwijt'],
    aangekomen: ['bezorgd', 'ontvangen', 'geleverd', 'bestelling'],
    ontvangen: ['bezorgd', 'geleverd', 'bestelling', 'aangekomen'],
    track: ['tracking', 'trace', 'volgen', 'verzending', 'volgnummer'],
    tracking: ['track', 'trace', 'volgen', 'verzending'],
    trace: ['track', 'tracking', 'volgen', 'verzending'],
    volgen: ['track', 'tracking', 'trace', 'verzending', 'zending'],
    volgnummer: ['track', 'tracking', 'trace'],
    thuis: ['bezorging', 'bezorgen', 'afwezig', 'buren'],
    afwezig: ['thuis', 'bezorging', 'niet'],
    // verzendkosten
    verzendkosten: ['verzending', 'gratis', 'bezorgkosten', 'kosten'],
    verzendkost: ['verzendkosten', 'verzending', 'gratis'],
    bezorgkosten: ['verzendkosten', 'verzending', 'gratis'],
    verzendprijs: ['verzendkosten', 'verzending', 'kosten'],
    verzenden: ['verzending', 'versturen', 'opsturen', 'bezorgen'],
    versturen: ['verzenden', 'opsturen', 'verzending'],
    // retour / ruilen / geld terug
    retour: ['retourneren', 'terugsturen', 'terug', 'herroepen', 'herroepingsrecht'],
    retourneren: ['retour', 'terugsturen', 'terug', 'herroepen'],
    retourneer: ['retour', 'retourneren', 'terugsturen'],
    retournering: ['retour', 'retourneren', 'terugsturen'],
    terugsturen: ['retour', 'retourneren', 'terug', 'opsturen'],
    terugstuur: ['retour', 'retourneren', 'terug'],
    opsturen: ['retour', 'terugsturen', 'verzenden'],
    herroepen: ['retour', 'herroepingsrecht', 'terug'],
    herroepingsrecht: ['retour', 'herroepen', 'bedenktijd'],
    ruilen: ['retour', 'ruil', 'omruilen', 'wisselen'],
    ruil: ['retour', 'ruilen', 'omruilen'],
    omruilen: ['retour', 'ruilen', 'wisselen'],
    wisselen: ['retour', 'ruilen', 'omruilen'],
    geld: ['terugbetaling', 'terug', 'betaling', 'retour', 'restitutie'],
    terug: ['retour', 'terugbetaling', 'geld', 'retourneren'],
    terugbetaling: ['geld', 'retour', 'terug', 'restitutie'],
    terugbetaald: ['terugbetaling', 'retour', 'geld'],
    restitutie: ['terugbetaling', 'geld', 'retour'],
    refund: ['terugbetaling', 'geld', 'retour'],
    bedenktijd: ['retour', 'retourtermijn', 'dagen', 'herroepingsrecht'],
    retourtermijn: ['retour', 'bedenktijd', 'dagen'],
    retourkosten: ['retour', 'kosten', 'retourneren'],
    annuleren: ['annuleren', 'bestelling', 'wijzigen', 'herroepen'],
    annulering: ['annuleren', 'bestelling', 'herroepen'],
    // garantie / defect
    garantie: ['garantie', 'defect', 'kapot', 'waarborg'],
    garantietermijn: ['garantie', 'termijn', 'maanden'],
    waarborg: ['garantie'],
    kapot: ['garantie', 'defect', 'stuk', 'beschadigd', 'mankement'],
    defect: ['garantie', 'kapot', 'stuk', 'mankement', 'storing'],
    stuk: ['garantie', 'defect', 'kapot'],
    beschadigd: ['garantie', 'kapot', 'defect', 'beschadiging'],
    mankement: ['garantie', 'defect', 'kapot'],
    storing: ['garantie', 'defect', 'kapot', 'werkt'],
    werkt: ['garantie', 'defect', 'kapot', 'storing'],
    // betaling
    betalen: ['betaalmethoden', 'betaling', 'betaalmethode', 'afrekenen'],
    betaling: ['betaalmethoden', 'betalen', 'betaalmethode'],
    betaalmethode: ['betaalmethoden', 'betalen', 'betaling'],
    betaalwijze: ['betaalmethoden', 'betalen', 'betaling'],
    afrekenen: ['betaalmethoden', 'betalen', 'betaling'],
    pinnen: ['betaalmethoden', 'betalen', 'ideal'],
    ideal: ['betaalmethoden', 'betalen'],
    paypal: ['betaalmethoden', 'betalen'],
    klarna: ['betaalmethoden', 'achteraf', 'betalen'],
    creditcard: ['betaalmethoden', 'betalen'],
    mastercard: ['betaalmethoden', 'betalen', 'creditcard'],
    visa: ['betaalmethoden', 'betalen', 'creditcard'],
    bancontact: ['betaalmethoden', 'betalen'],
    factuur: ['betaling', 'bon', 'betaalbewijs'],
    bon: ['factuur', 'betaling', 'betaalbewijs'],
    // bestelling-issues
    mist: ['ontbreekt', 'incompleet', 'bestelling', 'onvolledig'],
    ontbreekt: ['mist', 'incompleet', 'bestelling'],
    incompleet: ['mist', 'ontbreekt', 'onvolledig', 'bestelling'],
    onvolledig: ['mist', 'incompleet', 'bestelling'],
    verkeerd: ['verkeerde', 'fout', 'artikel', 'bestelling'],
    verkeerde: ['verkeerd', 'fout', 'artikel'],
    fout: ['verkeerd', 'artikel', 'bestelling'],
    wijzigen: ['aanpassen', 'bestelling', 'annuleren', 'adres'],
    aanpassen: ['wijzigen', 'bestelling', 'adres'],
    adres: ['wijzigen', 'aanpassen', 'bestelling'],
    // ophalen
    ophalen: ['afhalen', 'ophalen', 'persoonlijk'],
    afhalen: ['ophalen', 'afhalen', 'persoonlijk'],
    afhaalpunt: ['ophalen', 'afhalen'],
    langskomen: ['ophalen', 'afhalen', 'persoonlijk'],
    // vertrouwen / verkopen / conditie
    betrouwbaar: ['betrouwbaar', 'veilig', 'echt', 'reviews'],
    veilig: ['betrouwbaar', 'veilig', 'echt'],
    oplichting: ['betrouwbaar', 'veilig', 'echt', 'nep'],
    nep: ['betrouwbaar', 'echt', 'oplichting'],
    review: ['betrouwbaar', 'beoordeling', 'reviews'],
    verkopen: ['verkopen', 'inkoop', 'inruilen', 'verkoop'],
    inruilen: ['verkopen', 'inruil', 'inkoop'],
    verkoop: ['verkopen', 'inkoop', 'inruilen'],
    tweedehands: ['gebruikt', 'kwaliteit', 'staat', 'conditie'],
    gebruikt: ['tweedehands', 'kwaliteit', 'staat', 'conditie'],
    refurbished: ['tweedehands', 'gebruikt', 'kwaliteit'],
    conditie: ['staat', 'kwaliteit', 'tweedehands'],
    kwaliteit: ['staat', 'conditie', 'tweedehands']
  };

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function toks(s) { return norm(s).split(' ').filter(function (t) { return t.length >= 3 && !STOPMAP[t]; }); }
  function expand(ts) {
    var w = {};
    ts.forEach(function (t) { w[t] = 2; (SYN[t] || []).forEach(function (x) { if (!w[x]) w[x] = 1; }); });
    return w;
  }
  function scoreText(qn, an, weights, whole) {
    var sc = 0, tok;
    for (tok in weights) {
      if (!weights.hasOwnProperty(tok)) continue;
      var w = weights[tok];
      if (new RegExp('\\b' + tok).test(qn)) sc += 3 * w; else if (qn.indexOf(tok) !== -1) sc += 2 * w;
      if (an.indexOf(tok) !== -1) sc += 1 * w;
    }
    if (whole.length >= 5 && qn.indexOf(whole) !== -1) sc += 6;
    return sc;
  }
  // items: [{q, a, el?}] — geeft gesorteerde [{item, s}] terug
  function rank(items, query) {
    var weights = expand(toks(query)), whole = norm(query);
    var out = items.map(function (it) {
      if (it._qn === undefined) { it._qn = norm(it.q); it._an = norm(it.a || ''); }
      return { item: it, s: scoreText(it._qn, it._an, weights, whole) };
    });
    out.sort(function (a, b) { return b.s - a.s; });
    return out;
  }

  var CHEV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  /* ---------- Klantenservice FAQ-zoeker (DOM-blokken) ---------- */
  function initHelp() {
    var THRESH = 3;
    document.addEventListener('input', function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('[data-rw-faqsearch]')) return;
      var scope = input.closest('.rw-help__main') || document;
      var list = scope.querySelector('[data-rw-faqlist]');
      if (!list) return;
      var none = scope.querySelector('[data-rw-faqnone]');
      var term = none ? none.querySelector('[data-rw-faqterm]') : null;
      var suggest = scope.querySelector('[data-rw-faqsuggest]');
      var slot = suggest ? suggest.querySelector('[data-rw-suggest-slot]') : null;
      var moreLbl = scope.querySelector('[data-rw-faqmore]');
      var faqs = [].slice.call(list.querySelectorAll('[data-rw-faq]'));
      var raw = input.value.trim(), lc = raw.toLowerCase();

      faqs.forEach(function (f) { f.hidden = false; f.open = false; });
      if (suggest) suggest.hidden = true;
      if (moreLbl) moreLbl.hidden = true;
      if (!raw) { if (none) none.hidden = true; return; }

      var items = faqs.map(function (f) {
        var q = f.querySelector('.rw-faq__q'), a = f.querySelector('.rw-faq__a');
        return { el: f, q: q ? q.textContent : '', a: a ? a.textContent : '' };
      });
      var scored = rank(items, raw);

      var shown = 0;
      scored.forEach(function (o) {
        var vis = o.s > 0 || o.item.el.textContent.toLowerCase().indexOf(lc) !== -1;
        o.item.el.hidden = !vis; if (vis) shown++;
      });

      var best = scored[0];
      if (best && best.s >= THRESH && slot) {
        var clone = best.item.el.cloneNode(true);
        clone.removeAttribute('data-rw-faq'); clone.hidden = false; clone.open = true; clone.classList.add('rw-faq--insuggest');
        slot.innerHTML = ''; slot.appendChild(clone);
        suggest.hidden = false;
        best.item.el.hidden = true; if (shown > 0) shown--;
        if (moreLbl) moreLbl.hidden = shown <= 0;
      }
      if (none) { none.hidden = !(shown === 0 && (!best || best.s < THRESH)); if (term) term.textContent = raw; }
    });
  }

  /* ---------- Contact: live antwoorden terwijl de mail wordt getypt ---------- */
  function initContact() {
    var kbEl = document.getElementById('rw-faq-kb');
    var box = document.querySelector('[data-rw-contactsuggest]');
    if (!kbEl || !box) return;
    var slot = box.querySelector('[data-rw-contactsuggest-slot]');
    var kb;
    try { kb = JSON.parse(kbEl.textContent); } catch (err) { return; }
    if (!kb || !kb.length) return;
    var THRESH = 4, MAX = 3;

    function subjText() {
      var sel = document.querySelector('#cf-subject');
      if (!sel) return '';
      var v = sel.value || '';
      return (v === 'Algemene vraag' || v === 'Iets anders') ? '' : v;
    }
    function run() {
      var msg = '';
      var t = document.querySelector('[data-rw-contact-msg]');
      if (t) msg = t.value || '';
      var query = (msg + ' ' + subjText()).trim();
      if (toks(query).length < 2) { box.hidden = true; slot.innerHTML = ''; return; }
      var scored = rank(kb, query).filter(function (o) { return o.s >= THRESH; }).slice(0, MAX);
      if (!scored.length) { box.hidden = true; slot.innerHTML = ''; return; }
      var html = '';
      scored.forEach(function (o, i) {
        html += '<details class="rw-csug__item"' + (i === 0 ? ' open' : '') + '>' +
          '<summary class="rw-csug__q"><span class="rw-csug__mark">?</span>' + esc(o.item.q) +
          '<span class="rw-csug__chev">' + CHEV + '</span></summary>' +
          '<div class="rw-csug__a rte">' + (o.item.a || '') + '</div></details>';
      });
      slot.innerHTML = html;
      box.hidden = false;
    }
    function esc(s) { return (s || '').replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }

    var t = document.querySelector('[data-rw-contact-msg]');
    if (t) t.addEventListener('input', run);
    var sel = document.querySelector('#cf-subject');
    if (sel) sel.addEventListener('change', run);
  }

  window.RewayFaqMatch = { norm: norm, toks: toks, rank: rank };
  function boot() { initHelp(); initContact(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
